/**
 * Utility Functions
 */

/**
 * Lock/unlock body scroll
 * @param {boolean} lock - true to lock, false to unlock
 */
export function lockScroll(lock = true) {
    if (lock) {
        document.body.classList.add('popup-open');
    } else {
        document.body.classList.remove('popup-open');
    }
}

/**
 * Check if element is in viewport
 * @param {Element} elem 
 * @returns {boolean}
 */
export function isInViewport(elem) {
    const elemBounding = elem.getBoundingClientRect();
    const elemHeight = elem.offsetHeight;
    const elemWidth = elem.offsetWidth;

    return (
        elemBounding.top >= -elemHeight &&
        elemBounding.left >= -elemWidth &&
        elemBounding.right <= (window.innerWidth || document.documentElement.clientWidth) + elemWidth &&
        elemBounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + elemHeight
    );
}

/**
 * Debounce function
 * @param {Function} func 
 * @param {number} wait 
 * @param {boolean} immediate 
 * @returns {Function}
 */
export function debounce(func, wait, immediate) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            timeout = null;
            if (!immediate) func(...args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func(...args);
    };
}